import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { SocialProof } from '../components/landing/SocialProof';
import { CredibilitySection } from '../components/landing/CredibilitySection';
import { MechanismSection } from '../components/landing/MechanismSection';
import { WhoIsForSection } from '../components/landing/WhoIsForSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { ContentMapSection } from '../components/landing/ContentMapSection';
import { PriceBox } from '../components/landing/PriceBox';
import { FAQSection } from '../components/landing/FAQSection';
import { Footer } from '../components/landing/Footer';
import { StickyMobileCTA } from '../components/landing/StickyMobileCTA';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  const {
    trackEvent
  } = useMetaPixel();
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  useEffect(() => {
    document.documentElement.lang = 'es';
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsHeaderVisible(true);
      } else {
        setIsHeaderVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-[#0f0f0f] text-white font-sans selection:bg-[#C9A84C] selection:text-black" data-id="element-149">
      {/* Sticky Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 bg-[#0f0f0f]/90 backdrop-blur-md border-b border-[#2a2a2a] transition-transform duration-300 ${isHeaderVisible ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-150">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-151">
          <span className="text-[#C9A84C] font-serif font-bold tracking-wider text-sm md:text-base" data-id="element-152">
            EL AZÚCAR SILENCIOSO
          </span>
        </div>
      </header>

      <main data-id="element-153">
        <HeroSection data-id="element-154" />
        <CredibilitySection data-id="element-155" />
        <MechanismSection data-id="element-156" />
        <WhoIsForSection data-id="element-157" />
        <BenefitsSection data-id="element-158" />
        <ContentMapSection data-id="element-159" />
        <PriceBox onAddToCart={() => trackEvent('AddToCart')} data-id="element-160" />
        <FAQSection data-id="element-161" />
      </main>

      <Footer data-id="element-162" />
      <StickyMobileCTA data-id="element-163" />
    </div>;
}